import FilterTextField from '../baseInputTypes/FilterTextField'

export const PerformanceNumber = () => (
  <FilterTextField
    label="Performance Number"
    fieldPath={'productInformation.performanceNo'}
  />
)
